import React, { memo, useEffect, useCallback, useState } from 'react';
import styled from 'styled-components';
import { Title2, Headline } from '../../../components/Typography';
import {
  ORDER_REFUNDED,
  ORDER_REJECTED,
  ORDER_SUBMITTED,
  ORDER_ACCEPTED,
  ORDER_COMPLETE,
  ORDER_ON_DELIVERY,
  ORDER_READY_TO_PICKUP,
  ORDER_OUT_FOR_DELIVERY,
  ORDER_DELIVERED,
} from '../orderStatusTypes';
import calculateOrderReadyTime from '../utils/calculateOrderReadyTime';
import { withStyles } from '@material-ui/core';
import Dialog from '../../../components/Dialog/Dialog';
import ProductPreview from './ProductPreview';
import Receipt from './Receipt';
import PaymentMethod from './PaymentMethod';
import moment from 'moment';
import Icon from './Icon';
import TrackButton from './TrackButton';
import CloseButton from '../../../components/CloseButton/CloseButton';
import {
  PICKUP,
  DELIVERY,
  DROPOFF,
} from '../../OrderSetting/orderSettingTypes';
import StepsSummary from './StepsSummary';
import appConfig from '../../../../app-config';
const Wrapper = styled.div`
  display: grid;
`;

const ContentWrapper = styled.div`
  position: absolute;
  left: 25px;
  bottom: 25px;
  @media (max-width: 479px) {
    padding: 5px;
    margin: 0;
  }
`;

const Content = styled.div`
  padding: 10px 0;
  @media (max-width: 480px) {
    margin: 0;
  }
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
`;

const Title = styled(Title2)`
  color: ${(props) => props.theme.orderStatusTitleColor};
  margin-bottom: 10px;
  margin-left: 5px;
`;

const DetailsWrapper = styled.div`
  padding: 2rem 24px 50px 24px;
  display: grid;
  grid-gap: 32px;
`;

const DetailWrapper = styled.div`
  display: grid;
  grid-gap: 22px;
`;

const DetailTitle = styled(Headline)`
  font-weight: 600;
  width: max-content;

  :after {
    content: '';
    display: block;
    width: calc(100% + 2px);
    border-bottom: ${(props) => props.categoriesBarSelectedBorderColorWidth}
      solid ${(props) => props.theme.orderStatusTitleBarBorderColor};
  }
`;

const ReceiptWrapper = styled.div`
  // margin: auto;
  display: flex;
  justify-content: flex-end;
`;

const NoteWraper = styled.div`
  width: 100%;
  margin: 0 5px 20px 0;
`;

const NoteText = styled.span`
  width: 100%;
  height: 17px;
  white-space: pre-line;
  margin: 0 0 0 4px;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.02px;
  color: var(--colors-basic-dark);
`;
const Line = styled.hr`
  width: 100%;
  color: #c1c1c1;
  margin: 0;
`;

const StatusCardWrapper = styled.div`
  position: relative;
  padding: 32px 16px 32px 24px;
  height: 17rem;
  background: ${(props) => props.theme.orderStatusBackgroundColor};
  background-repeat: no-repeat;
  background-size: 100%;
  border-radius: 10px;
  cursor: ${(props) => !props.isForModal && 'pointer'};
  justify-content: center;
  &:hover {
    background: ${(props) =>
      !props.isForModal && props.theme.orderStatusBackgroundColorHover};
    background-repeat: no-repeat;
    background-size: 100%;
    transition: all 0.25s ease;
  }

  @media (max-width: 480px) {
    height: 12rem;
    padding: 15px;
  }
`;

const OrderStatusMessage = styled.div`
  font-size: ${(props) => props.theme.orderStatusMessageFontSize || '16px'};
  padding-right: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  white-space: pre-wrap;
  font-family: ${(props) => props.font || ''};
  color: ${(props) => props.customColor || 'black'};
  @media (max-width: 480px) {
    text-overflow: ellipsis;
    max-height: 100px;
    overflow: hidden !important;
    font-size: 13px;
  }
`;

const OrderStatusSubMessage = styled.div`
  font-size: ${(props) => props.theme.orderStatusSubMessageFontSize || '14px'};
  margin: 8px 0 0;
  margin-right: 25px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.02px;
  white-space: pre-wrap;
  hyphens: none;
  font-family: ${(props) => props.font || ''};
  color: ${(props) => props.customColor || '#737a87'};
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

const Separator = styled.div`
  width: 15%;
  height: 4px;
  border-radius: 2px;
  background-color: #b4c3db;
  margin: 0px 1em 0px 1em;
`;

const styles = () => ({
  scrollPaper: {},
  paper: {
    borderRadius: '10px',
  },
});

const OrderStatusBody = ({
  orderType,
  status,
  businessName,
  orderReadyTime,
  deliveryTrackingURL,
  delay,
  index,
  displayComplete,
  statusMessage,
  isFutureOrder,
  minPrepTime,
}) => {
  return (
    <ContentWrapper>
      {status === ORDER_COMPLETE && displayComplete && (
        <Content>
          {appConfig.styleConfig.orderStatusStep3Icon &&
          orderType === 'pickup' ? (
            <img src={appConfig.styleConfig.orderStatusStep3Icon} />
          ) : appConfig.styleConfig.orderStatusStep3IconDelivery &&
            orderType === 'delivery' ? (
            <img src={appConfig.styleConfig.orderStatusStep3IconDelivery} />
          ) : (
            <Icon className='fas fa-badge-check' />
          )}
        </Content>
      )}
      {(status === ORDER_REFUNDED || status === ORDER_REJECTED) && (
        <Content>
          <Icon className='fas fa-exclamation-triangle' />
        </Content>
      )}
      {status === ORDER_SUBMITTED && (
        <Content>
          {appConfig.styleConfig.orderStatusStep1Icon &&
          orderType === 'pickup' ? (
            <img src={appConfig.styleConfig.orderStatusStep1Icon} />
          ) : appConfig.styleConfig.orderStatusStep1IconDelivery &&
            orderType === 'delivery' ? (
            <img src={appConfig.styleConfig.orderStatusStep1IconDelivery} />
          ) : (
            <Icon className='fas fa-check-circle' />
          )}
        </Content>
      )}
      {status === ORDER_ACCEPTED && (
        <Content>
          {appConfig.styleConfig.orderStatusStep2Icon &&
          orderType === 'pickup' ? (
            <img src={appConfig.styleConfig.orderStatusStep2Icon} />
          ) : appConfig.styleConfig.orderStatusStep2IconDelivery &&
            orderType === 'delivery' ? (
            <img src={appConfig.styleConfig.orderStatusStep2IconDelivery} />
          ) : (
            <Icon className='fas fa-hat-chef' />
          )}
        </Content>
      )}
      {(status === ORDER_ON_DELIVERY ||
        status === ORDER_READY_TO_PICKUP ||
        status === ORDER_OUT_FOR_DELIVERY ||
        status === ORDER_DELIVERED) && (
        // !displayComplete &&
        <Content>
          <RenderOrderCompleteIcon orderType={orderType} status={status} />
        </Content>
      )}
      {appConfig.styleConfig.isStaticOrderStatus ? (
        <>
          <OrderStatusMessage
            customColor={appConfig.styleConfig.orderStatusTitleColor}
            font={appConfig.styleConfig.orderStatusMessageFont}
          >
            {(status === ORDER_REFUNDED || status === ORDER_REJECTED) && (
              <>
                {
                  'Unfortunately, we cannot fulfill your order at this time. Your order will be refunded.'
                }
              </>
            )}
            {orderType === 'pickup' &&
              status !== ORDER_REFUNDED &&
              status !== ORDER_REJECTED && (
                <>
                  {isFutureOrder
                    ? appConfig.styleConfig.orderStatusPickupFutureMessage
                    : appConfig.styleConfig.orderStatusPickupASAPMessage}
                </>
              )}
            {orderType === 'delivery' &&
              status !== ORDER_REFUNDED &&
              status !== ORDER_REJECTED && (
                <>
                  {isFutureOrder
                    ? appConfig.styleConfig.orderStatusDeliveryFutureMessage
                    : appConfig.styleConfig.orderStatusDeliveryASAPMessage}
                </>
              )}
            {orderType === 'drop_off' &&
              status !== ORDER_REFUNDED &&
              status !== ORDER_REJECTED && (
                <>
                  {isFutureOrder
                    ? appConfig.styleConfig.orderStatusDropOffFutureMessage
                    : appConfig.styleConfig.orderStatusDropOffASAPMessage}
                </>
              )}
          </OrderStatusMessage>
          <OrderStatusSubMessage
            customColor={appConfig.styleConfig?.orderStatusSubtitleColor}
            font={appConfig.styleConfig?.orderStatusMessageFont}
          >
            {orderType === 'pickup' &&
              status !== ORDER_REFUNDED &&
              status !== ORDER_REJECTED && (
                <>
                  {!isFutureOrder &&
                    appConfig.styleConfig.orderStatusPickupASAPMessage2 &&
                    `${appConfig.styleConfig.orderStatusPickupASAPMessage2} ${minPrepTime} minutes`}
                  {isFutureOrder &&
                    appConfig.styleConfig.orderStatusPickupFutureMessage2}
                </>
              )}
            {orderType === 'delivery' &&
              status !== ORDER_REFUNDED &&
              status !== ORDER_REJECTED && (
                <>
                  {!isFutureOrder &&
                    appConfig.styleConfig.orderStatusDeliveryASAPMessage2 &&
                    `${appConfig.styleConfig.orderStatusDeliveryASAPMessage2} ${minPrepTime} minutes`}
                  {isFutureOrder &&
                    appConfig.styleConfig.orderStatusDeliveryFutureMessage2}
                </>
              )}
          </OrderStatusSubMessage>
        </>
      ) : (
        <OrderStatusMessage
          customColor={appConfig.styleConfig?.orderStatusTitleColor}
          font={appConfig.styleConfig?.orderStatusMessageFont}
        >
          {status === ORDER_SUBMITTED ? (
            <>
              {appConfig.appSource === 'maker'
                ? "Your order has been received. We'll update you once we start preparing it!"
                : 'Your order has been placed'}
              <OrderStatusSubMessage
                customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                font={appConfig.styleConfig.orderStatusMessageFont}
              >
                {appConfig.appSource !== 'maker' &&
                  'Waiting for restaurant confirmation…'}
              </OrderStatusSubMessage>
            </>
          ) : status === ORDER_ACCEPTED && delay === 0 ? (
            <>
              Your order is being prepared
              <OrderStatusSubMessage
                customColor={appConfig.styleConfig?.orderStatusSubtitleColor}
                font={appConfig.styleConfig?.orderStatusMessageFont}
              >
                {`It will be ready by ${orderReadyTime}`}
              </OrderStatusSubMessage>
            </>
          ) : status === ORDER_ACCEPTED && delay > 0 ? (
            <>
              Your order is being prepared
              <OrderStatusSubMessage
                customColor={appConfig.styleConfig?.orderStatusSubtitleColor}
                font={appConfig.styleConfig?.orderStatusMessageFont}
              >
                {`It will be ready by ${orderReadyTime}. Please contact the store for more information.`}
              </OrderStatusSubMessage>
            </>
          ) : status === ORDER_READY_TO_PICKUP &&
            orderType === 'pickup' &&
            !displayComplete ? (
            <>
              Your order is ready for pickup
              <OrderStatusSubMessage
                customColor={appConfig.styleConfig?.orderStatusSubtitleColor}
                font={appConfig.styleConfig?.orderStatusMessageFont}
              >
                {`at ${businessName}`}
              </OrderStatusSubMessage>
            </>
          ) : (status === ORDER_ON_DELIVERY ||
              status === ORDER_OUT_FOR_DELIVERY ||
              status === ORDER_DELIVERED) &&
            orderType === 'delivery' &&
            !displayComplete ? (
            <>
              {status === ORDER_DELIVERED ? (
                <div>
                  Your order has been delivered
                  <div style={{ marginTop: '25px' }}>
                    <TrackButton deliveryTrackingURL={deliveryTrackingURL} />
                  </div>
                </div>
              ) : (
                <>
                  Your order is out for delivery
                  {deliveryTrackingURL ? (
                    <div style={{ marginTop: '25px' }}>
                      <TrackButton deliveryTrackingURL={deliveryTrackingURL} />
                    </div>
                  ) : (
                    <OrderStatusSubMessage
                      customColor={
                        appConfig.styleConfig.orderStatusSubtitleColor
                      }
                      font={appConfig.styleConfig.orderStatusMessageFont}
                    >
                      {`It will be delivered by ${orderReadyTime}`}
                    </OrderStatusSubMessage>
                  )}
                </>
              )}
            </>
          ) : status === 2 && orderType === 'drop_off' && !displayComplete ? (
            <>
              Your order is ready for drop-off
              <OrderStatusSubMessage
                customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                font={appConfig.styleConfig.orderStatusMessageFont}
              >
                {`at ${businessName}`}
              </OrderStatusSubMessage>
            </>
          ) : status === ORDER_REFUNDED || status === ORDER_REJECTED ? (
            <div>{statusMessage}</div>
          ) : status === ORDER_COMPLETE && displayComplete ? (
            <div>Your order is complete!</div>
          ) : null}
        </OrderStatusMessage>
      )}
    </ContentWrapper>
  );
};
const OrderDetailTitle = styled.div`
  height: 17px;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.02px;
  color: black;
  margin: 0 0 10px 0;
`;

const OrderDetailsBody = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto auto auto;
`;

const VerticalRect = styled.div`
  width: 2px;
  height: 50px;
  border-radius: 1px;
  background-color: #c6d3ed;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2px;
`;

const OrderDetailDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${(props) => (props.alignRight ? 'flex-end' : 'flex-start')};
  height: ${(props) => (props.small ? '15px' : '45px')};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #737a87;
`;

const OrderDetailTitleDesc = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${(props) => (props.alignRight ? 'flex-end' : 'flex-start')};
  height: 45px;
  font-family: Inter;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 3px;
  padding: 5px;
  margin-top: ${(props) => (props.lastItem ? '45px' : '5px')};
  height: 70px;
`;

const SeparatorLine = styled.div`
  width: 100%;
  height: 1px;
  border: solid 1px #ebebeb;
`;

const RenderOrderCompleteIcon = ({ orderType, status, displayComplete }) => {
  if (orderType === PICKUP)
    return (
      <>
        {appConfig.styleConfig.orderStatusStep3Icon ? (
          <img src={appConfig.styleConfig.orderStatusStep3Icon} />
        ) : (
          <>
            {status === ORDER_READY_TO_PICKUP ? (
              <Icon className='fas fa-store' />
            ) : (
              <Icon className='fal fa-store' />
            )}
          </>
        )}
      </>
    );

  if (orderType === DELIVERY)
    return (
      <>
        {appConfig.styleConfig.orderStatusStep3IconDelivery ? (
          <img src={appConfig.styleConfig.orderStatusStep3IconDelivery} />
        ) : (
          <>
            {status === ORDER_ON_DELIVERY ||
            status === ORDER_OUT_FOR_DELIVERY ? (
              <Icon className='fas fa-car-side' />
            ) : (
              <Icon className='fas fa-badge-check' />
            )}
          </>
        )}
      </>
    );

  if (orderType === DROPOFF)
    return (
      <>
        {appConfig.styleConfig.orderStatusStep3IconDropoff ? (
          <img src={appConfig.styleConfig.orderStatusStep3IconDropoff} />
        ) : (
          <>
            {status === ORDER_COMPLETE ? (
              <Icon className='fas fa-shopping-bag' />
            ) : (
              <Icon className='fal fa-shopping-bag' />
            )}
          </>
        )}
      </>
    );
};

const OrderStatusModal1 = ({
  orderStatusModalData,
  setOrderStatusModalData,
  classes,
  orderDelayMessage,
  currency,
  is_tip_enabled,
  displayComplete,
  locations,
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const updatePhoneNumber = useCallback(() => {
    if (orderStatusModalData) {
      const businessId = orderStatusModalData?.business_id;
      const selectedBusiness = locations?.find(
        (business) => business.id === businessId
      );
      if (selectedBusiness) {
        setPhoneNumber(selectedBusiness.phone);
      }
    }
  }, [orderStatusModalData]);
  useEffect(() => {
    updatePhoneNumber();
  }, [updatePhoneNumber]);
  if (!orderStatusModalData) return null;
  const status = orderStatusModalData?.status;
  const businessName = orderStatusModalData?.business_name;
  const orderType = orderStatusModalData?.order_type;
  const orderReadyTime = calculateOrderReadyTime(orderStatusModalData, false);
  const minPrepTime = moment
    .duration(orderStatusModalData?.min_prep_time, 'HH:mm:ss')
    .asMinutes();
  const deliveryTrackingURL = orderStatusModalData?.delivery_tracking_url;
  const delay = orderStatusModalData?.delay;
  const statusMessage = orderStatusModalData?.status_change_message
    ? orderStatusModalData?.status_change_message
    : ' Unfortunately, we cannot fulfill your order at this time. Your order will be refunded.';
  return (
    <Dialog
      open={orderStatusModalData}
      classes={classes}
      onBackdropClick={() => setOrderStatusModalData(null)}
      scroll='body'
      maxWidth={'md'}
      fullWidth={true}
    >
      <Wrapper>
        <StatusCardWrapper>
          <TitleWrapper>
            <Title id='OrderStatus-Title'>Order Status</Title>
            <div>
              <CloseButton
                id='OrderStatusModal-SetOrderStatus'
                onClick={() => setOrderStatusModalData(null)}
              />
            </div>
          </TitleWrapper>

          <OrderStatusBody
            orderType={orderType}
            status={status}
            businessName={businessName}
            orderReadyTime={orderReadyTime}
            deliveryTrackingURL={deliveryTrackingURL}
            delay={delay}
            displayComplete={displayComplete}
            statusMessage={statusMessage}
            isFutureOrder={orderStatusModalData?.is_future_order}
            minPrepTime={minPrepTime}
          />
        </StatusCardWrapper>
        <DetailsWrapper>
          {status !== ORDER_REFUNDED && status !== ORDER_REJECTED && (
            <StepsSummary
              orderStatusModalData={orderStatusModalData}
              orderReadyTime={orderReadyTime}
              phoneNumber={phoneNumber}
              displayComplete={displayComplete}
              locations={locations}
            />
          )}

          <DetailWrapper>
            <DetailTitle id='OrderStatusModal-OrderSummary'>
              Your Items
            </DetailTitle>
            <ProductPreview
              products={orderStatusModalData?.flatProducts}
              isForPreview
            />
          </DetailWrapper>
          {orderStatusModalData?.special_instruction && (
            <DetailWrapper>
              <DetailTitle id='OrderStatusModal-OrderSummary'>
                Order Instructions
              </DetailTitle>
              <NoteWraper>
                <NoteText>{orderStatusModalData?.special_instruction}</NoteText>
              </NoteWraper>
              <Line size='2' />
            </DetailWrapper>
          )}
          <DetailWrapper>
            {/* <DetailTitle>Order Summary</DetailTitle> */}
            <ReceiptWrapper>
              <Receipt
                id='OrderStatusModal-Receipt'
                orderSummary={{
                  ...orderStatusModalData?.order_summary,
                  currency: orderStatusModalData?.currency
                    ? orderStatusModalData?.currency
                    : currency,
                  orderMethodType: orderStatusModalData?.order_type,
                  serviceFees: orderStatusModalData?.service_fees,
                }}
                is_tip_enabled={is_tip_enabled}
              />
            </ReceiptWrapper>
          </DetailWrapper>
          {orderStatusModalData?.order_summary?.total > 0 ? (
            <DetailWrapper>
              <DetailTitle id='OrderStatusModal-PaymentMethod'>
                Payment Method
              </DetailTitle>
              <PaymentMethod
                paymentMethod={orderStatusModalData?.payments[0]}
              />
            </DetailWrapper>
          ) : null}
        </DetailsWrapper>
      </Wrapper>
    </Dialog>
  );
};

export default withStyles(styles)(memo(OrderStatusModal1));
